import { render, staticRenderFns } from "./cLandingV3FeedbackStrip.vue?vue&type=template&id=3c916aab"
import script from "./cLandingV3FeedbackStrip.vue?vue&type=script&lang=js"
export * from "./cLandingV3FeedbackStrip.vue?vue&type=script&lang=js"
import style0 from "./v3Widgets.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports